/* eslint-disable no-unused-vars */
export default {
	getToken(state) {
		return state?.token?.token;
	},

	getRefreshToken(state) {
		return state?.token?.refreshToken;
	},

	getUser(state) {
		return state.user;
	},

	getUserCustomer(state) {
		return state.user?.customer;
	},

	getActiveBuilding(state) {
		return state.activeBuilding;
	},

	getActiveCustomer(state) {
		return state.activeCustomer;
	},

	getActiveCompany(state) {
		return state.activeCompany;
	},

	isLoggedIn(state, getters) {
		return Boolean(getters.getToken);
	},

	totalPages: state => {
		return state.totalPages;
	},

	totalCount: state => {
		return state.totalCount;
	},

	currentPage: state => {
		return state.searchParams.currentPage;
	},

	pageSize: state => {
		return state.searchParams.pageSize;
	},

	users: state => {
		return state.users;
	},

	dropdownUsers: state => {
		return state.dropdownUsers;
	},

	pagination: state => {
		return {
			currentPage: state.searchParams.currentPage,
			pageSize: state.searchParams.pageSize,
			totalPages: state.totalPages,
			totalCount: state.totalCount
		};
	},

	allowCustomerApiKey: state => {
		return true;

		return state.user?.customer?.allowCustomerApiKey;
	},

	isWebSbaAdmin: state => {
		return state.token?.role?.some(x => x === 'WebSbaAdmin');
	},

	isSbaTechnician: state => {
		return state.token?.role?.some(x => x === 'SbaTechnician');
	},

	isCompanyAdmin: state => {
		return state.token?.role?.some(x => x === 'CompanyAdmin');
	},

	isCustomerAdmin: state => {
		return state.token?.role?.some(x => x === 'CustomerAdmin');
	},

	isAdmin: state => {
		return state.token?.role?.some(x => x === 'Admin');
	},

	isUser: state => {
		return state.token?.role?.some(x => x === 'User');
	},

	isBasicUser: state => {
		return state.token?.role?.some(x => x === 'BasicUser');
	},

	isBasicUserLight: state => {
		return state.token?.role?.some(x => x === 'BasicUserLight');
	}
};
